import React from 'react';
import { ShieldCheck, Zap, Lock } from 'lucide-react';
export function FinalCTA() {
  const handleCheckout = () => {
    window.location.href = 'https://productosdigitalesnuevos.myshopify.com/checkouts/cn/hWN9n9b8dLQ0zWcM4lh6BQg6/es-ar?_r=AQAB3sxDrVfYMB8G5oC3KtOEXxVl3WNVcpKRPbVzMknQ1i0&cart_link_id=QdC5wTSR&preview_theme_id=146146721979';
  };
  return <section className="relative py-24 overflow-hidden" data-id="element-26">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-27">
        <img src="https://cdn.magicpatterns.com/uploads/qhBhsxM5oeZW7sF7zAMMQT/ChatGPT_Image_11_mar_2026,_12_08_23_a.m..png" alt="Colección de postres" className="w-full h-full object-cover opacity-30" data-id="element-28" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0d0906] via-[#0d0906]/80 to-[#0d0906]" data-id="element-29"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-4xl text-center" data-id="element-30">
        <h2 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-31">
          No dejes pasar esta{' '}
          <span className="gold-gradient-text" data-id="element-32">oportunidad</span>
        </h2>

        <p className="text-xl md:text-2xl text-[#c9b99a] mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-33">
          El mejor momento para empezar tu propio negocio fue ayer. El segundo
          mejor momento es hoy. Da el primer paso hacia tu independencia
          económica.
        </p>

        <button onClick={handleCheckout} className="btn-gold animate-shimmer-btn text-xl md:text-2xl py-5 px-10 mb-12 w-full sm:w-auto" data-id="element-34">
          Quiero Empezar Mi Negocio Ahora
        </button>

        <div className="flex flex-col md:flex-row justify-center items-center gap-8 text-[#c9b99a]" data-id="element-35">
          <div className="flex items-center gap-2" data-id="element-36">
            <Lock className="w-5 h-5 text-[#d4a843]" data-id="element-37" />
            <span data-id="element-38">Pago 100% Seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-39">
            <Zap className="w-5 h-5 text-[#d4a843]" data-id="element-40" />
            <span data-id="element-41">Acceso Inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-42">
            <ShieldCheck className="w-5 h-5 text-[#d4a843]" data-id="element-43" />
            <span data-id="element-44">Garantía de 30 días</span>
          </div>
        </div>
      </div>
    </section>;
}